/* eslint-disable prefer-template */
import { IconButton } from "@material-ui/core";
import { Search } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SimDataGrid from "../../shared/data-grid/SimDataGrid";
import { supabase } from "../../../supabase";

/**
 * @function
 * @param {object} props Component props
 * @param {string} props.type Type of dealers to fetch. Can be "pending", "approved", or "declined"
 * @returns {React.ReactElement} A page displaying a table of dealers with the given type
 * @description
 * This component fetches a list of dealers from the database based on the given type.
 * It then renders a table of the dealers with columns for the date, name, surname, phone, and submitted by.
 * The table also includes a column with a button that links to the detail page of the dealer.
 */
export default function Approvals(props) {
  const [dealers, setDealers] = useState([]);
  const { type } = props;

  useEffect(() => {
    supabase
      .schema(process.env.REACT_APP_SB_SCHEMA)
      .from("users_master")
      .select(
        `
            id,
            created_at,
            first_name,
            middle_name,
            surname,
            phone,
            submitted_by_auth_id,
            parent_id,
            parent_name:submitted_by_auth_id(first_name),
            parent_middle_name:submitted_by_auth_id(middle_name),
            parent_surname:submitted_by_auth_id(surname)
        `
      )
      .eq("refs_user_lifecycle_status_id", type)
      .eq("phone_verified", true)
      .eq("email_verified", true)
      .not("submitted_by_auth_id", "is", null)
      .then(result => {
        setDealers(result.data);
      })
      .catch(err => {
        console.error(err, "ERROR");
      });
  }, []);

  const rows =
    dealers &&
    dealers.map(r => ({
      id: dealers.id,
      ...r,
    }));

  const columns = [
    {
      field: "action",
      headerName: "Detail",
      width: 80,
      renderCell: params => (
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ cursor: "pointer" }}
        >
          <Link to={`/approval-detail/${params.row.id}`}>
            <IconButton>
              <Search />
            </IconButton>
          </Link>
        </div>
      ),
    },
    { field: "created_at", headerName: "Date", width: 200 },
    {
      field: "first_name",
      headerName: "Name",
      width: 200,
      renderCell: params => (
        <div>
          {params.row.first_name}
          {params.row.middle_name ? " " + params.row.middle_name : ""}
        </div>
      ),
    },
    { field: "surname", headerName: "Surname", width: 200 },
    { field: "phone", headerName: "Phone", width: 200 },
    {
      headerName: "Submitted By",
      width: 200,
      renderCell: params => (
        <div>
          {params.row.parent_name && (
            <div>
              {params.row.parent_name.first_name}
              {params.row.parent_name.middle_name
                ? " " + params.row.parent_name.middle_name
                : ""}{" "}
              {params.row.parent_surname.surname}
            </div>
          )}
        </div>
      ),
    },
  ];

  return <SimDataGrid data={rows} columns={columns} />;
}
